import {
  getListToolbarBulkDeleteButtonClass,
  getListToolbarPrimaryActionButtonClass,
  getListToolbarSearchInputClass,
  getListToolbarSortToggleClass,
  getListToolbarViewModeButtonClass,
  LIST_TOOLBAR_DOWNLOAD_MENU_CLASS,
  LIST_TOOLBAR_DOWNLOAD_MENU_ITEM_CLASS,
  LIST_TOOLBAR_DOWNLOAD_TRIGGER_CLASS,
  LIST_TOOLBAR_REGISTER_MENU_CLASS,
  LIST_TOOLBAR_REGISTER_MENU_ITEM_CLASS,
} from "../common/listToolbarSharedStyles";

export const TEACHER_LIST_TOOLBAR_LEFT_GROUP_CLASS = "flex-1 flex flex-wrap gap-2 items-center";

export const TEACHER_LIST_TOOLBAR_TAB_GROUP_BASE_CLASS =
  "flex bg-gray-100/50 rounded-[2rem] p-1.5 border border-gray-200/60 shadow-inner flex-shrink-0 items-center gap-1";

export const TEACHER_LIST_TOOLBAR_SEARCH_WRAPPER_CLASS = "relative flex-1 max-w-sm min-w-[200px]";

export const TEACHER_LIST_TOOLBAR_SEARCH_ICON_CLASS = "absolute left-4 top-1/2 -translate-y-1/2 text-gray-400";

export const TEACHER_LIST_TOOLBAR_SORT_GROUP_CLASS = "flex items-center gap-2 flex-shrink-0";

export const TEACHER_LIST_TOOLBAR_VIEW_TOGGLE_WRAP_CLASS =
  "flex bg-white rounded-[2rem] p-[2px] border border-gray-200 shadow-sm flex-shrink-0 items-center h-11";

export const TEACHER_LIST_TOOLBAR_RIGHT_ACTIONS_CLASS = "flex gap-2 items-center";

export const TEACHER_LIST_TOOLBAR_DOWNLOAD_TRIGGER_CLASS = LIST_TOOLBAR_DOWNLOAD_TRIGGER_CLASS;
export const TEACHER_LIST_TOOLBAR_DOWNLOAD_MENU_CLASS = LIST_TOOLBAR_DOWNLOAD_MENU_CLASS;
export const TEACHER_LIST_TOOLBAR_DOWNLOAD_MENU_ITEM_CLASS = LIST_TOOLBAR_DOWNLOAD_MENU_ITEM_CLASS;
export const TEACHER_LIST_TOOLBAR_REGISTER_MENU_CLASS = LIST_TOOLBAR_REGISTER_MENU_CLASS;
export const TEACHER_LIST_TOOLBAR_REGISTER_MENU_ITEM_CLASS = LIST_TOOLBAR_REGISTER_MENU_ITEM_CLASS;

export function getTeacherListToolbarContainerClass(isMobile) {
  return `sticky top-6 z-40 bg-white/80 backdrop-blur-xl rounded-[2rem] shadow-lg border border-white/50 p-1.5 flex flex-col md:flex-row justify-between items-center gap-2 transition-all duration-300 ${
    isMobile ? "-mt-6 top-0 rounded-none border-t-0 border-x-0 bg-[#F0F0EB]/90" : ""
  }`;
}

export function getTeacherListToolbarTabGroupClass(isMobile) {
  return `${TEACHER_LIST_TOOLBAR_TAB_GROUP_BASE_CLASS} ${isMobile ? "h-10" : "h-11"}`;
}

export function getTeacherListToolbarTabButtonClass(isActive, themeBgClass, isMobile) {
  return `w-28 rounded-[1.5rem] text-sm font-bold flex items-center justify-center ${
    isActive ? `${themeBgClass} text-white` : "text-gray-400 hover:text-gray-600 hover:bg-white/50"
  } ${isMobile ? "h-7" : "h-9"}`;
}

export function getTeacherListToolbarSearchInputClass(theme) {
  return getListToolbarSearchInputClass(theme);
}

export function getTeacherListToolbarSortToggleClass(sortOrder, themeTextClass) {
  return getListToolbarSortToggleClass(sortOrder, themeTextClass);
}

export function getTeacherListToolbarSelectAllButtonClass(selectedCount) {
  return `w-11 h-11 rounded-full transition-all border border-transparent flex items-center justify-center gap-1 ${
    selectedCount > 0 ? "bg-[#354F38]/10 text-[#354F38] border-[#354F38]/20" : "text-gray-400 hover:text-gray-600"
  }`;
}

export function getTeacherListToolbarSelectAllIconClass(selectedCount) {
  return selectedCount > 0 ? "fill-[#354F38] text-white" : "";
}

export function getTeacherListToolbarViewModeButtonClass(isActive, theme) {
  return getListToolbarViewModeButtonClass(isActive, theme);
}

export function getTeacherListToolbarBulkDeleteButtonClass(selectedCount) {
  return getListToolbarBulkDeleteButtonClass(selectedCount);
}

export function getTeacherListToolbarPrimaryActionButtonClass(themeBgClass) {
  return getListToolbarPrimaryActionButtonClass(themeBgClass);
}
